const DESKTOP_BREAKPOINT = 1256;
export const MAX_DESKTOP_BREAKPOINT = `${DESKTOP_BREAKPOINT}px`;
export const MIN_DESKTOP_BREAKPOINT = `${DESKTOP_BREAKPOINT + 1}px`;

const MODIFIED_DESKTOP_BREAKPOINT = 549;
export const MODIFIED_MAX_BREAKPOINT = `${MODIFIED_DESKTOP_BREAKPOINT}px`;
export const MODIFIED_MIN_BREAKPOINT = `${MODIFIED_DESKTOP_BREAKPOINT + 1}px`;
